var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLobbyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6736_1686)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6736_1686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28639 9.87502C7.73254 9.44898 7.03491 9.19336 6.2787 9.19336C5.74615 9.19336 5.22959 9.31584 4.76627 9.55549C4.30296 9.31584 3.78639 9.19336 3.25385 9.19336C1.45917 9.19336 0 10.6206 0 12.3726C0 15.0087 2.18343 17.2295 4.76627 17.2295C6.18284 17.2295 7.47692 16.5584 8.36095 15.52C7.7432 14.5827 7.41302 13.4963 7.41302 12.3726C7.41302 11.4354 7.73787 10.5673 8.28639 9.87502Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7858 7.84509C10.871 7.99421 10.9615 8.13799 11.0521 8.27645C11.2704 8.2445 11.4941 8.2232 11.7231 8.2232C11.9094 8.2232 12.1012 8.23385 12.2876 8.26048C12.0958 7.98888 11.8935 7.69066 11.7018 7.36048C11.0254 6.19953 10.6154 5.02793 10.4769 3.85101C10.5781 3.9735 10.6899 4.09065 10.8124 4.20249C12.0532 5.33148 13.9704 5.36876 14.0503 5.36876C14.0503 5.36876 14.0503 5.36876 14.0556 5.36876C14.1941 5.36876 14.3325 5.31551 14.4284 5.22497C14.5296 5.13444 14.5828 5.00663 14.5828 4.87882C14.5828 4.80426 14.5455 3.05752 13.3047 1.92852C12.0692 0.804856 10.1627 0.767578 10.0668 0.767578C10.0562 0.767578 10.0455 0.767578 10.0349 0.767578C9.95501 0.767578 9.87513 0.78888 9.8059 0.826158C8.52247 1.44923 7.42543 2.32793 6.55738 3.44095C5.86507 4.32497 5.31122 5.35811 4.91182 6.50841C4.6775 7.19006 4.52306 7.83444 4.42188 8.38296C4.53903 8.41492 4.65619 8.45219 4.76803 8.48947C5.00767 8.40426 5.2633 8.33503 5.51359 8.29243C5.60412 7.83977 5.73726 7.33385 5.91832 6.79598C6.62128 4.76699 7.78755 3.22261 9.39051 2.18415C9.23608 4.07468 9.71004 6.01314 10.7805 7.83977L10.7858 7.84509Z",
    fill: "#8C8989"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7474 9.19336C14.2149 9.19336 13.6983 9.31584 13.235 9.55549C12.7717 9.31584 12.2551 9.19336 11.7226 9.19336C9.92792 9.19336 8.46875 10.6206 8.46875 12.3726C8.46875 15.0087 10.6522 17.2295 13.235 17.2295C15.8179 17.2295 18.0013 15.0034 18.0013 12.3726C18.0013 10.6206 16.5421 9.19336 14.7474 9.19336Z",
    fill: "#8C8989"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6736_1686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6736_1686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16.4663,
    fill: "white",
    transform: "translate(0 0.767578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobbyIcon);
export default __webpack_public_path__ + "static/media/Lobby_icon.1f0eb2e04d321aac766056737d573a5f.svg";
export { ForwardRef as ReactComponent };